// Una sección del tablero de marca con la estética de Cumbre
// (ADR-2026-10-02-onboarding-v2-tablero-con-cumbre). Sólo existe cuando su parte ya se
// analizó: lo que falta va junto en `AnalisisEnCurso`, no como esqueletos tarjeta por
// tarjeta. Entra con un salto; si llegó todo de una, en cascada (`orden`).

import type { ReactNode } from 'react';

export function SeccionDeMarca(p: {
  titulo: string;
  /** Glifo de Material Symbols Rounded. */
  icono: string;
  /** Si el análisis no lo encontró: qué hacer, en lugar del contenido. */
  falta?: string | null;
  /** Botones (Cambiar, Editar…), a la derecha del título. */
  acciones?: ReactNode;
  /** Texto chico a la derecha del título cuando no hay acciones. */
  nota?: string;
  /** Posición en la cascada cuando todo llega junto. Sin ella, entra sola. */
  orden?: number;
  className?: string;
  children?: ReactNode;
}) {
  return (
    <section
      className={`om-seccion ${p.className ?? ''}`}
      style={p.orden !== undefined ? { ['--orden' as string]: p.orden } : undefined}
    >
      <header className="om-seccion__cabeza">
        <span className="om-seccion__icono material-symbols-rounded" aria-hidden="true">
          {p.icono}
        </span>
        <h2 className="om-seccion__titulo">{p.titulo}</h2>
        {p.acciones ? (
          <div className="ml-auto flex shrink-0 gap-1.5">{p.acciones}</div>
        ) : p.nota ? (
          <span className="om-seccion__nota">{p.nota}</span>
        ) : null}
      </header>
      {p.falta && <p className="om-seccion__falta">{p.falta}</p>}
      {p.children}
    </section>
  );
}

export function BotonDeSeccion(p: { onClick: () => void; children: ReactNode; label?: string }) {
  return (
    <button type="button" onClick={p.onClick} aria-label={p.label} className="om-seccion__boton">
      {p.children}
    </button>
  );
}

export default SeccionDeMarca;
